var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"","visible":_vm.onDrawerVisible,"with-header":false,"size":_vm.size},on:{"update:visible":function($event){_vm.onDrawerVisible=$event},"closed":_vm.onCloseDrawer}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }